import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppLayoutService {
  showLayout = signal(true);

  hideFullLayout() {
    this.showLayout.set(false);
  }

  showFullLayout() {
    this.showLayout.set(true);
  }
}
